/* eslint-disable react/jsx-pascal-case */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { ADM_OUT_5_sales_release } from '../../KanbanBoards/cells/ADM/ADM_OUT_5_sales_release';
import { ADM_OUT_5_sales_release_not_home } from '../../KanbanBoards/cells/ADM/ADM_OUT_5_sales_release_not_home';
import { WS1_4_TestDrive } from '../../KanbanBoards/cells/WS/WS1_4_TestDrive';

import { WS2_1_Interior } from '../../KanbanBoards/cells/WS/WS2_1_Interior';
import { WS2_6_InteriorPictures } from '../../KanbanBoards/cells/WS/WS2_6_InteriorPictures';
import { WS_Plannable } from '../../KanbanBoards/cells/WS/WS_Plannable';
import { Loader } from '../../../components/Loader';
import { fetchActions } from '../../Actions/actions';
import { selectActions } from '../../Actions/selectors';

import { WS2_7_ExteriorInspection } from '../../KanbanBoards/cells/WS/WS2_7_ExteriorInspection';
import { Transport_in_eu } from '../../KanbanBoards/cells/Transport/Transport_in_eu';
import { Transport_in_eu_planned_1 } from '../../KanbanBoards/cells/Transport/Transport_in_eu_planned_1';

import { Transport_out_eu_planned_1 } from '../../KanbanBoards/cells/Transport/Transport_out_eu_planned_1';
import { Transport_out_eu } from '../../KanbanBoards/cells/Transport/Transport_out_eu';
import { WS1_8_PreInspection } from '../../KanbanBoards/cells/WS/WS1_8_PreInspection';
import { IDWE_transport_nl_individual } from '../../KanbanBoards/cells/Transport/IDWE_transport_nl_individual';
import { IDWE_transport_out_individual } from '../../KanbanBoards/cells/Transport/IDWE_transport_out_individual';
import { IDWE_claim_for_review } from '../../KanbanBoards/cells/COM/IDWE_claim_for_review';
import { IDWE_transport_nl_out_combined } from '../../KanbanBoards/cells/Transport/IDWE_transport_nl_out_combined';
import { IDWE_transport_in_nl_expected } from '../../KanbanBoards/cells/Transport/IDWE_transport_in_nl_expected';
import { MobileActionPage } from '../../KanbanBoards/pages/mobileActionPage';
import { HOOI_interior_inspection_mobile_page } from '../../KanbanBoards/cells/HOOI/HOOI_interior_inspection_mobile_page';
import { HOOI_hours } from '../../KanbanBoards/cells/HOOI/HOOI_hours';
import { HILT_assign_parking } from '../../KanbanBoards/cells/HILT/HILT_assign_parking';
import { HILT_appraise } from '../../KanbanBoards/cells/HILT/HILT_appraise';
import { HILT_intake } from '../../KanbanBoards/cells/HILT/HILT_intake';
import { HILT_check_in } from '../../KanbanBoards/cells/HILT/HILT_check_in';
import { HILT_ready_for_sale } from '../../KanbanBoards/cells/HILT/HILT_ready_for_sale';
import { HILT_invoicing } from '../../KanbanBoards/cells/HILT/HILT_invoicing';
import { HILT_advertise_combine } from '../../KanbanBoards/cells/HILT/HILT_advertise_combine';
import { HOOI_NEW_other } from '../../KanbanBoards/cells/HOOI/HOOI_NEW_other';



import { WS_FINAL_INSPECTION } from '../../KanbanBoards/cells/WS/WS_FINAL_INSPECTION';
import { AUTOHUIS_task_1 } from '../../KanbanBoards/cells/AUTOHUIS/AUTOHUIS_task_1';
import { HILT_wait_for_transport } from '../../KanbanBoards/cells/HILT/HILT_wait_for_transport';
// import { HILT_realease_for_transport } from '../../KanbanBoards/cells/HILT/HILT_realease_for_transport';
// import { HILT_ready_for_sale } from '../../KanbanBoards/cells/HILT/HILT_ready_for_sale';
import { IDW_export_overview } from '../../KanbanBoards/cells/ADM/IDW_export_overview';
import { HOOI_NEW_order_key_program_dealer } from '../../KanbanBoards/cells/HOOI/HOOI_NEW_order_key_program_dealer';
import { HOOI_NEW_store_personal_belongings } from '../../KanbanBoards/cells/HOOI/HOOI_NEW_store_personal_belongings';
import { HOOI_NEW_license_plate_order_install } from '../../KanbanBoards/cells/HOOI/HOOI_NEW_license_plate_order_install';

import { HOOI_NEW_external_repair } from '../../KanbanBoards/cells/HOOI/HOOI_NEW_external_repair';
import { HOOI_new_key_ordered } from '../../KanbanBoards/cells/HOOI/HOOI_new_key_ordered';

import { IDWEFINfactureren_combine_akkoord } from '../../KanbanBoards/cells/FIN/IDWEFINfactureren_combine_akkoord';
import { ADM_IN_3_purchase_release } from '../../KanbanBoards/cells/ADM/ADM_IN_3_purchase_release';
const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class VehicleDetailsActionsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    console.log('mount detailsActions');
    this.props.fetchActions();
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get documents() {
    return this.props.vehicle?.documents ?? [];
  }

  get entityId() {
    return this.vehicle?.id;
  }

  get entityType() {
    return 'vehicle';
  }

  getActionIdByName(name) {
    return this.props?.actions?.find(a => a.functionName === name)?.id ?? null;
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Container>
       Assign HOOI_NEW_other
        <HOOI_new_key_ordered

          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('HOOI_NEW_other') }}
          column={{ label: 'label' }}
        />
        HOOI_hours:
        <HOOI_hours cell={{ vehicle: this.vehicle }} action={{ label: 'label' }} column={{ label: 'label' }} />
        HOOI_hours:
        <HOOI_hours
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('HOOI_hours') }}
          column={{ label: 'Plannable' }}
          payload={{ task_name: 'task_spray' }}
        />
        {/* WS_Plannable :
        <WS_Plannable
          plannable
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('WS_Plannable') }}

          column={{ label: 'Plannable' }}
        /> */}
        WS2_6_InteriorPictures:
     
        Transport indivdual to plan:
        <IDWE_transport_nl_individual
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('IDWE_transport_nl_individual') }}
          column={{ label: 'label' }}
        />
        Transport indivdual to out:
        <IDWE_transport_out_individual
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('IDWE_transport_out_individual') }}
          column={{ label: 'label' }}
        />
        IDWE_claim_for_review:
        <IDWE_claim_for_review
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('IDWE_claim_for_review') }}
          column={{ label: 'label' }}
        />
        WS2_1_Interior :
        <WS2_1_Interior
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
          column={{ label: 'Inspectie' }}
        />
        WS1_4_TestDrive :
        <WS1_4_TestDrive
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('WS1_4_TestDrive') }}
          column={{ label: 'Proefrit' }}
        />
        IDWE_transport_nl_out_combined:
        <IDWE_transport_nl_out_combined
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('IDWE_transport_nl_out_combined') }}
          column={{ label: 'IDWE_transport_nl_out_combined' }}
        />
        WS_Plannable :
        {/* <WS_Plannable
          plannable
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('WS_Plannable') }}
          payload={{ task_name: 'HILT_repair_order' }}
          column={{ label: 'Plannable' }}
        />
        WS1_8_PreInspection"
        <WS1_8_PreInspection
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('WS1_8_PreInspection') }}
          column={{ label: 'WS1_8_PreInspection' }}
        />
        Transport_in_eu :
        <Transport_in_eu
          plannable
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('Transport_in_eu') }}
          //payload={{ task_name: 'task_spray' }}
          column={{ label: 'Transport_in_eu' }}
        />
        Transport_in_eu :
        <Transport_in_eu_planned_1
          plannable
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('Transport_in_eu_planned_1') }}
          //payload={{ task_name: 'task_spray' }}
          column={{ label: 'Transport_in_eu_planned_1' }}
        />
        Transport_in_eu :
        <Transport_in_eu_planned_1
          plannable
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('Transport_in_eu_planned_1') }}
          //payload={{ task_name: 'task_spray' }}
          column={{ label: 'Transport_in_eu_planned_1' }}
        />
        IDWE_transport_in_nl_expected :
        <IDWE_transport_in_nl_expected
          plannable
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('IDWE_transport_in_nl_expected') }}
          //payload={{ task_name: 'task_spray' }}
          column={{ label: 'IDWE_transport_in_nl_expected' }}
        />
        Transport_out_eu :
        <Transport_out_eu
          plannable
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('Transport_out_eu') }}
          //payload={{ task_name: 'task_spray' }}
          column={{ label: 'Transport_out_eu' }}
        />
        WS2_1_Interior:
        <WS2_1_Interior
          cell={{ vehicle: this.vehicle }}
          action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
          payload={{ task_name: 'task_spray' }}
          column={{ label: 'WS2_7_ExteriorInspection' }}
        />
        {/* HOOI_interior_inspection_mobile_page:
        <HOOI_interior_inspection_mobile_page
          // cell={{ vehicle: this.vehicle }}
          loggedInUserId={this.props.loggedInUserId}
          vehicleId={this.vehicle?.id}
          board_id={this.boardId}
          action={{ label: 'label', id: this.getActionIdByName('WS2_1_Interior') }}
          payload={{ task_name: 'task_spray' }}
          column={{ label: 'WS2_7_ExteriorInspection' }}
        /> */}
      </Container>
    );
  }
}

VehicleDetailsActionsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    actions: selectActions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetchActions() {
      dispatch(fetchActions());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDetailsActions = compose(withConnect, withRouter)(VehicleDetailsActionsComp);
